module.exports = __webpack_public_path__ + "static/media/invoices-dollar.fb9f685f.svg";